import { Flex, Text } from "@chakra-ui/react";

export default function DataUpload() {
	return (
		<Flex direction='column' pt={'20px'}>
			<Text>Data upload</Text>
		</Flex>
	)
}